import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MUSCLE_CMD_WRITE, MUSCLE_CONVERT_FAC} from '../../../core/consts/consts';
import {auditTime, throttleTime} from 'rxjs/operators';
import {interval, Subscription} from 'rxjs';
import {MuscleDataService} from '../../../services/muscle-data.service';
import {GeniusChartService} from '../../../services/genius-chart/genius-chart.service';
import {CalculateAverageService} from '../../../services/calculateAverage/calculate-average.service';
import {IUser} from '../../../core/interfaces/user';
import {CurrentUserService} from '../../../services/current-user/current-user.service';
import {ExgPacket, ExgPacketDecoder} from '../../../core/interfaces/exg_interface';
import * as moment from 'moment';
import {TourService} from 'ngx-ui-tour-md-menu';
import {TranslateService} from '@ngx-translate/core';
import {ChartLabelsService} from "../../../services/chart-labels/chart-labels.service";

@Component({
  selector: 'kt-raw-chart',
  templateUrl: './raw-chart.component.html',
  styleUrls: ['./raw-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RawChartComponent implements OnInit, OnDestroy {

  @ViewChild('mainRawChart', {static: true}) rawChart: any;

  sensorData;
  lineChart;
  dataType: string;
  chartTime = 0.1;
  selectedAverage = 60;
  selectedChannel = 'samples_ch1';
  maxChartZoom = 1000;
  minChartZoom: number;
  maxChartSeconds = 10;
  zoomStep = 16;
  timeArray = [];
  muscleDataSubscription: Subscription;
  dataConditionSubscription: Subscription;
  middleValuesSubscription: Subscription;
  refreshChartSubscription: Subscription;
  bluetoothServiceSubscription: Subscription;
  bluetoothService;
  chartTimeStarted: Date;
  currentChartTime: Date;
  startTimeSaved = false;
  isDataStreaming = false;
  twoChannelsAverage;

  secondsArray = [];
  singleSecond = 0;
  singleValue = 0;
  chartLabelsLength: number;
  dataArray = [];
  datasetInterval = null;
  chartUpdateInterval: number;
  test = false;
  currentUser: IUser;
  nominalTime = 0;
  secondsArra = [0,2.3,2.32,2.33,2.35,2.36,2.37,2.39,2.4,2.42,2.45,2.46,2.47,2.48,2.5,2.52,2.54,2.55,2.56,2.58,2.59,2.61,2.62,2.63,2.64,2.65,2.66,2.67,2.68,2.69,2.7,2.71,2.72,2.73,2.75,2.76,2.77,2.78,2.79,2.8,2.81,2.82,2.83,2.84,2.86,2.87,2.88,2.89,2.9,2.91,2.92,2.93,2.94,2.95,2.96,2.97,2.98,3,3.01,3.03,3.04,3.05,3.06,3.07,3.08,3.09,3.1,3.11,3.12,0,3.14,3.15,3.16,3.18,3.19,3.2,3.21,3.22,3.23,3.24,3.25,3.26,3.27,3.28,3.29,3.3,3.31,3.32,3.33,3.34,3.35,3.36,3.37,3.38,3.39,3.4,3.42,3.43,3.44,3.46,3.47,3.48,3.49,3.5,3.52,3.53,3.54,3.55,3.56,3.58,3.59,3.6,3.61,3.62,3.63,3.64,3.65,3.66,3.67,3.68,3.69,3.7,3.72,3.73,3.74,3.75,3.76,3.77,3.78,3.79,3.81,3.82,3.83,3.84,3.85,3.86,3.87,3.88,3.89,0,3.91,3.92,3.93,3.94,3.95,3.96,3.97,3.98,3.99,4,4.01,4.02,4.03,4.04,4.05,4.06,4.07,4.08,4.1,4.11,4.12,4.14,4.15,4.16,4.17,4.19,4.2,4.21,4.22,4.23,4.24,4.25,4.26,4.28,0,4.3,4.31,4.32,4.33,4.34,4.35,4.36,4.38,4.39,4.4,4.41,4.42,4.43,4.44,4.45,4.46,4.47,4.48,4.49,4.5,4.51,4.52,4.54,4.55,4.56,4.57,4.58,4.59,4.6,4.61,4.62,4.63,4.64,4.65,4.66,4.67,4.69,4.71,4.72,4.74,4.78,4.79,4.8,4.81,4.82,4.83,4.84,4.86,4.87,4.88,4.89,4.91,4.92,4.93,4.94,4.96,4.98,4.99,5.02,5.04,5.05,5.07,5.08,5.09,5.1,5.12,5.13,5.14,5.15,5.16,5.17,5.19,5.2,5.21,5.22,5.24,5.25,5.27,5.28,5.29,5.3,5.32,5.33,5.34,5.36,5.37,5.38,5.39,5.4,5.42,5.43,5.44,5.45,0,5.48,5.49,5.5,5.51,5.52,5.53,5.54,5.55,5.56,5.58,5.59,5.6,5.61,5.62,5.63,5.64,5.65,5.66,5.67,5.68,5.69,5.7,5.71,5.73,5.75,5.76,5.77,5.78,5.79,5.8,5.81,5.83,5.84,0,5.87,5.88,5.89,5.9,5.91,5.92,5.93,5.94,5.95,5.96,5.97,5.98,5.99,6,6.01,6.02,6.03,6.04,6.05,6.06,6.07,6.09,6.11,6.14,6.15,6.16,6.18,6.19,6.2,6.21,6.22,6.23,6.24,0,6.26,6.27,6.28,6.29,6.3,6.31,6.32,6.33,6.35,6.36,6.37,6.38,6.39,6.4,6.42,6.43,6.44,6.45,6.46,6.47,6.48,6.49,6.5,6.51,6.52,6.53,6.54,6.55,6.56,6.57,6.58,6.6,6.62,0,6.65,6.67,6.68,6.7,6.71,6.72,6.73,6.74,6.75,6.76,6.77,6.78,6.79,6.8,6.81,6.82,6.83,6.84,6.85,6.86,6.87,6.88,6.89,6.91,6.92,6.93,6.94,6.96,6.97,6.98,6.99,7,0,7.03,7.04,7.05,7.06,7.07,7.08,7.1,7.12,7.13,7.15,7.16,7.18,7.19,7.21,7.22,7.25,7.27,7.28,7.3,7.31,7.33,7.34,7.35,7.37,7.38,7.39,7.4,0,7.43,7.44,7.45,7.46,7.47,7.48,7.49,7.5,7.51,7.52,7.53,7.54,7.55,7.56,7.57,7.58,7.59,7.61,7.63,7.64,7.65,7.66,7.67,7.68,7.69,7.7,7.71,7.73,7.74,7.75,7.76,7.77,0,7.8,7.82,7.83,7.84,7.86,7.87,7.89,7.9,7.91,7.92,7.94,7.96,7.97,7.98,7.99,8,8.01,8.02,8.03,8.04,8.05,8.06,8.07,8.09,8.1,8.11,8.12,8.13,8.14,8.15,8.16,8.17,8.18,8.19,8.2,0,8.22,8.23,8.24,8.26,8.28,8.31,8.32,8.33,8.34,8.35,8.36,8.37,8.38,8.4,8.41,8.42,8.43,8.44,8.45,8.46,8.48,8.49,8.51,8.52,8.53,8.54,8.55,8.56,8.57,8.58,0,8.61,8.62,8.63,8.64,8.66,8.67,8.68,8.69,8.7,8.71,8.72,8.73,8.74,8.75,8.76,8.77,8.78,8.79,8.8,8.81,8.82,8.83,8.84,8.85,8.86,8.87,8.88,8.89,8.91,8.93,8.94,8.95,8.96,8.97,0,9,9.01,9.02,9.03,9.04,9.05,9.07,9.08,9.09,9.1,9.11,9.12,9.13,9.14,9.17,9.19,9.2,9.21,9.22,9.23,9.24,9.25,9.26,9.27,9.28,9.29,9.3,9.31,9.32,9.33,9.34,9.35,9.36,9.38,9.39,9.4,9.41,9.43,9.44,9.45,9.46,9.47,9.48,9.49,9.5,9.51,9.52,9.53,9.54,9.55,9.56,9.57,9.58,9.6,9.61,9.62,9.63,9.64,9.65,9.66,9.68,9.69,9.7,9.71,9.72,9.73,9.74,9.75,9.77,9.78,9.79,9.8,9.81,9.82,9.84,9.85,9.87,9.88,9.89,9.9,9.91,9.92,9.94,9.95,9.96,9.98,9.99,10,10.01]
  reverseChart = false;
  reverseInterval;
  reverseIntervalStarted = false;
  timeStarted;
  currentTime;

  constructor(
    private muscleData: MuscleDataService,
    private chartService: GeniusChartService,
    private average: CalculateAverageService,
    private cd: ChangeDetectorRef,
    private firebaseUser: CurrentUserService,
    private tour: TourService,
    private translates: TranslateService,
    private chartLabels: ChartLabelsService
  ) { }

  ngOnInit(): void {
    this.subscribeToBluetoothService();
    this.getSettingsFromLocalStorage();
    this.createRAWChart();
    this.getStreamingCondition();
    this.getSensorData();
    this.getUser();
  }

  ngOnDestroy():void {
    this.muscleDataSubscription.unsubscribe();
    this.rawChart.destroy();
    this.average.resetArrays();
    this.rawChart.data.labels = [];
    clearInterval(this.datasetInterval);
    this.reverseChart = false;
    this.reverseIntervalStarted = false;
    clearTimeout(this.reverseInterval);
    this.tour.end();
    this.startTimeSaved = false;
  }

  getUser() {
    this.firebaseUser.getCurrentUser().subscribe((user: IUser) => {
      this.currentUser = user;
      this.cd.markForCheck();
      if (user.showCoachMarks) {
        this.showCoachMarks();
      }
    });
  }

  showCoachMarks() {
    this.tour.initialize([
      {
        anchorId: 'channel-choose',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.CHANNEL_TEXT')}`,
      },
      {
        anchorId: 'y-asis',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.Y_AXIS_TEXT')}`,
      },
      {
        anchorId: 'x-length',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.SECONDS_TEXT')}`,
      },
      {
        anchorId: 'zoom-step',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.ZOOM_STEP_TEXT')}`,
      },
      {
        anchorId: 'line-chart',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.CENTER_CHART_TEXT')}`,
      },
      {
        anchorId: 'chart-zoom',
        content: `${this.translates.instant('SUPERVISOR_RAW_COACHMARKS.ZOOM_BUTTONS')}`,
      },
    ]);
    this.tour.steps.forEach((step) => {
      step.nextBtnTitle = `${this.translates.instant('COACHMARKS_BUTTONS.NEXT')}`;
      step.prevBtnTitle = `${this.translates.instant('COACHMARKS_BUTTONS.PREV')}`
      step.enableBackdrop = true
    });
    setTimeout(() => {
      this.tour.start();
    },1000);
  }

  async sendDataToActivateRAWmode(bluetoothService) {
    const cmdString = new TextEncoder().encode(`SET_PACKET(0x40,ON)`).buffer;
    const CmdWriteCharacteristic = await bluetoothService.getCharacteristic(MUSCLE_CMD_WRITE);
    console.log(bluetoothService.getCharacteristic)
    await CmdWriteCharacteristic.writeValue(cmdString);
  }

  subscribeToBluetoothService(){
    this.bluetoothServiceSubscription = this.muscleData.bluetoothServiceSubject.subscribe((service) =>{
      if(service) {
        this.bluetoothService = service;
      }
    })
  }

  getStreamingCondition() {
    this.dataConditionSubscription = this.muscleData.dataStreamingSubject.subscribe((dataCondition) => {
      if (dataCondition) {
        this.isDataStreaming = dataCondition;
      } else {
        if(this.refreshChartSubscription) {
          this.refreshChartSubscription.unsubscribe();
        }
      }
    });
  }

  getSensorData(): void {
    this.muscleDataSubscription = this.muscleData.muscleDataSubject.subscribe(async (data) => {
      if (data && data.data[this.selectedChannel]) {
        this.dataType = data.data_type_id_text;
        this.parseSensorData(data.data[this.selectedChannel]);
        this.nominalTime = data.data.nominalTime;
        if (!this.startTimeSaved && this.isDataStreaming) {
          this.startTimeSaved = true;
          await this.sendDataToActivateRAWmode(this.bluetoothService);
        }
      } else {
        this.isDataStreaming = false;
      }
    });
  }

  parseSensorData(data) {
    if (data) {
      switch (this.dataType) {
        case 'EEG_RAW' :
          const result = data[0] * MUSCLE_CONVERT_FAC;
          if (this.rawChart.data.datasets[0].data.length < this.chartLabelsLength) {
            this.rawChart.data.datasets[0].data.push(result);
            if (this.rawChart) {
              this.rawChart.update();
            }
          } else {
            this.rawChart.data.datasets[0].data.shift();
            this.rawChart.data.datasets[0].data.push(result);
            if (this.rawChart) {
              this.rawChart.update();
            }
          }
          if (!this.reverseIntervalStarted) {
            this.reverseIntervalStarted = true;
            this.reverseInterval = setTimeout(() => {
              this.reverseChart = true;
            }, this.maxChartSeconds  * 1000);
          }
      }
    }
  }

  createRAWChart() {
    let stepSize;
    if (this.maxChartSeconds <= 60) {
      stepSize = 1;
    } else if (this.maxChartSeconds >= 60) {
      stepSize = 10;
    }
    const lineChartCanvas = document.getElementById('mainLineChart');
    this.rawChart = this.chartService.createRawChart(lineChartCanvas, stepSize, this.maxChartZoom, this.maxChartZoom);
    this.rawChart.data.labels = this.chartLabels.generateRawChartLabels(this.maxChartSeconds);
    this.chartLabelsLength = this.rawChart.data.labels.length;
    this.rawChart.update();
    this.testInterval();
  }

  generateMuscleLineLabels(initialSecond: number, lineLengthInSeconds: number, refreshInterval, timestampsAmount = 10) {
    const lineLengthInMilliseconds = lineLengthInSeconds * 1000;
    const result = new Array((lineLengthInMilliseconds) / refreshInterval).fill(null)
    result[0] = this.timerView(initialSecond * 1000, true);

    if (lineLengthInSeconds <= 10) {
      const step = 1000 / refreshInterval;
      for (let index = 1; index <= lineLengthInSeconds; index++) {
        result[index * step - (step <= 2 ? 0 : 1)] = this.timerView((index + initialSecond) * 1000, true);
      }
    } else {
      const step = result.length / timestampsAmount;
      for (let index = 1; index <= timestampsAmount; index++) {
        result[index * step - 1] = this.timerView(((index * (lineLengthInSeconds / timestampsAmount)) + initialSecond) * 1000, true);
      }
    }
    return result;
  }

  timerView(recordingTime: number, checkForHours = false): string {
    const seconds = (moment.duration(recordingTime).seconds() < 10) ? '0' + moment.duration(recordingTime).seconds() : moment.duration(recordingTime).seconds();
    const minutes = (moment.duration(recordingTime).minutes() < 10) ? '0' + moment.duration(recordingTime).minutes() : moment.duration(recordingTime).minutes();
    const hours = (moment.duration(recordingTime).hours() < 10) ? '0' + moment.duration(recordingTime).hours() : moment.duration(recordingTime).hours();

    if(checkForHours){
      if(!moment.duration(recordingTime).hours()){
        return minutes + ':' + seconds;
      }
    }

    return hours + ':' + minutes + ':' + seconds;
  }


  changeChannel($event) {
    this.selectedChannel = $event.value;
    this.average.resetArrays();
    this.saveSettingsToLocalStorage();
  }

  testInterval() {
    if (!this.test) {
      this.test = true;
      setTimeout(() =>{
        console.log(this.rawChart.data.datasets[0].data.length)
      },1000)
    }
  }

  changeChartUpdateInterval($event) {
    this.timeStarted = null;
    if($event.target.value > 600 ) {
      this.maxChartSeconds = 600;
      this.saveSettingsToLocalStorage();
      setTimeout(() => {
        this.nullifyChart();
        this.createRAWChart();
      },1000)
      this.saveSettingsToLocalStorage();
      this.cd.markForCheck();
      return;
    }
    this.maxChartSeconds = +$event.target.value;
    if(this.refreshChartSubscription) {
      this.refreshChartSubscription.unsubscribe();
    }
    setTimeout(() => {
      this.nullifyChart();
      this.createRAWChart();
    },1000)
    this.saveSettingsToLocalStorage();
    // ExgPacketDecoder.resetDecoderTime();
    this.secondsArray = [];
    this.reverseChart = false;
    this.reverseIntervalStarted = false;
    clearTimeout(this.reverseInterval);
  }

  changeChartZoomLevelMin($event) {
    this.rawChart.options.scales.yAxes[0].ticks.min = +$event.target.value;
    this.rawChart.update();
    this.cd.markForCheck();
    this.saveSettingsToLocalStorage();
  }

  changeChartZoomLevelMax($event) {
    this.rawChart.options.scales.yAxes[0].ticks.max = +$event.target.value;
    this.rawChart.options.scales.yAxes[0].ticks.min = -$event.target.value;
    this.rawChart.update();
    this.cd.markForCheck();
    this.saveSettingsToLocalStorage();
  }

  zoomInChart() {
    this.rawChart.options.scales.yAxes[0].ticks.max = this.rawChart.options.scales.yAxes[0].ticks.max + +this.zoomStep;
    this.rawChart.options.scales.yAxes[0].ticks.min = this.rawChart.options.scales.yAxes[0].ticks.min - +this.zoomStep;
    this.minChartZoom = this.rawChart.options.scales.yAxes[0].ticks.min;
    this.rawChart.update();
    this.saveSettingsToLocalStorage();
  }

  zoomOutChart() {
    this.rawChart.options.scales.yAxes[0].ticks.min = this.rawChart.options.scales.yAxes[0].ticks.min + +this.zoomStep;
    this.rawChart.options.scales.yAxes[0].ticks.max = this.rawChart.options.scales.yAxes[0].ticks.max - +this.zoomStep;
    this.maxChartZoom = this.rawChart.options.scales.yAxes[0].ticks.max;
    this.rawChart.update();
    this.saveSettingsToLocalStorage();
  }

  getSettingsFromLocalStorage() {
    if (localStorage.length > 0 && localStorage.getItem('rawSettings')) {
      const settings = JSON.parse(localStorage.getItem('rawSettings'));
      this.selectedChannel = settings.selectedChannel;
      this.maxChartZoom = settings.maxChartZoom;
      this.maxChartSeconds = settings.maxChartSeconds;
      this.selectedAverage = settings.selectedAverage;
      this.zoomStep = settings.zoomStep;

      setTimeout(() => {
        this.rawChart.options.scales.yAxes[0].ticks.max = +settings.maxChartZoom;
        this.rawChart.options.scales.yAxes[0].ticks.min = -settings.maxChartZoom;
        this.rawChart.update();
        this.cd.markForCheck();
      },100)
    }
  }

  saveSettingsToLocalStorage() {
    const settings = JSON.parse(localStorage.getItem('rawSettings'));
    if (settings) {
      localStorage.removeItem('rawSettings');
    }
    const ratioSettings = {
      selectedChannel: this.selectedChannel,
      maxChartZoom: this.maxChartZoom,
      maxChartSeconds: this.maxChartSeconds,
      selectedAverage: this.selectedAverage,
      zoomStep: this.zoomStep,
    }
    localStorage.setItem('rawSettings', JSON.stringify(ratioSettings));
  }

  clearDataArray() {
    this.dataArray = [];
  }
  nullifyChart() {
    this.timeArray = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.rawChart.data.datasets.length; i++) {
      this.rawChart.data.datasets[i].data = [];
    }
  }
}

